import type { FilterConfig } from './useGQLSearch.ts';

export const BACKEND_CARD_SEARCH_FILTERS = {
  rarity: { api: 'rarity', type: 'string' },
  pos: { api: 'position', type: 'string' },
  al: {
    api: (lang: string) => `active_leagues.name_with_slug_${lang}`,
    type: 'string',
  },
  gameplay_tier: { api: 'gameplay_tier', type: 'string' },
  skin: { api: 'skin', type: 'string' },
  season: { api: 'season', type: 'string' },
  player: { api: 'player.display_name', type: 'string' },
  club: { api: 'active_club.long_name_with_slug', type: 'string' },
  team: { api: 'team.long_name_with_slug', type: 'string' },
  nt: {
    api: (lang: string) => `active_national_team.name_${lang}`,
    type: 'string',
  },
  nationality: {
    api: (lang: string) => `country.name_with_code_${lang}`,
    type: 'string',
  },
  ps: { api: 'player.playing_status', type: 'string' },
  'card_edition.display_name': {
    api: 'card_edition.display_name',
    type: 'string',
  },
  serial_number: { api: 'serial_number', type: 'numeric' },
  grade: { api: 'grade', type: 'numeric' },
  'sale.price': { api: 'sale.price', type: 'numeric' },
  b2e: { api: 'sale.bid_to_earn', type: 'string' },
  'sale.bundled': { api: 'sale.bundled', type: 'string' },
  'sale.settlement_wallets': {
    api: 'sale.settlement_wallets',
    type: 'string',
  },
  sale: { api: 'on_sale', type: 'string' },
  is: { api: 'in_season_eligible', type: 'string' },
  so5L5Avg: { api: 'so5.last_five_so5_average_score', type: 'numeric' },
  so5L10Avg: {
    api: 'so5.last_ten_played_so5_average_score',
    type: 'numeric',
  },
  so5L15Avg: { api: 'so5.last_fifteen_so5_average_score', type: 'numeric' },
  so5L5App: { api: 'so5.last_five_so5_appearances', type: 'numeric' },
  so5L15App: { api: 'so5.last_fifteen_so5_appearances', type: 'numeric' },
  age: { api: 'player.birth_date_i', type: 'numeric' },
  rcc: { api: 'revealable_card_campaign.name', type: 'menu' },
  ce: { api: 'ce', type: 'virtual' },
  gw: { api: 'playing_next', type: 'virtual' },
  dly: { api: 'playing_next', type: 'virtual' },
  pp: { api: 'pp', type: 'virtual' },
  promotion: { api: 'promotion', type: 'virtual' },
  lf: { api: 'lf', type: 'virtual' },
  ff: { api: 'ff', type: 'virtual' },
  wl: { api: 'wl', type: 'virtual' },
  dk: { api: 'dk', type: 'virtual' },
  nl: { api: 'lineup', type: 'virtual' },
  co: { api: 'collectible', type: 'virtual' },
  deck: { api: 'deck', type: 'virtual' },
} satisfies FilterConfig;
